import { format } from 'fecha';
import { IServiceResult } from '../../infrastructure/Interfaces/IServiceResult';
import { SVCPostulante } from '../../infrastructure/services/api/SVCPostulante';
import { SVCEtapasProcesos } from '../../infrastructure/services/api/SVCEtapasProcesos';
import IViewEtapas from '../../presentation/view-interfaces/IViewEtapas';
import IViewInstrucciones from '../../presentation/view-interfaces/IViewInstrucciones';
import IViewPostulaciones from '../../presentation/view-interfaces/IViewPostulaciones';
import IViewDeudaFinanciera from '../../presentation/view-interfaces/IViewDeudaFinanciera';

export const ObtienePostulaciones = (
    selListaPostulaciones: any,
    rut: number,
    anoProceso: number,
    periodoProceso: number,
    codigoNegocio: number,
    codigoPrograma: string,
    codigoPlanificacion: number,
    idPeriodo: number,
    headers: any
) => {
    let list: Array<IViewPostulaciones> = [];
    SVCPostulante.ObtienePostulaciones(rut, anoProceso, periodoProceso, codigoNegocio, codigoPrograma, codigoPlanificacion, idPeriodo, headers).then(
        (res: IServiceResult<any>) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                for (let c = 0; c <= data.length - 1; c++) {
                    list.push({
                        codsede: data[c].codsede,
                        codCarrera: data[c].codCarrera,
                        nombreCarrera: data[c].nombreCarrera,
                        numeroAlumno: data[c].numeroAlumno,
                        codVia: data[c].codVia,
                        tipo: data[c].tipo,
                        alumnoNuevo: data[c].alumnoNuevo,
                        matriculado: data[c].matriculado,
                        estadoAcademico: data[c].estadoAcademico,
                        matriculaEnLinea: data[c].matriculaEnLinea,
                        ano: data[c].ano,
                        periodo: data[c].periodo,
                        codPlanificacionAcademica: data[c].codPlanificacionAcademica,
                        codPlanEstudio: data[c].codPlanEstudio,
                        fechaInicio: format(new Date(data[c].fechaInicio), 'YYYY-MM-DD'),
                        negocio: data[c].negocio,
                        codigoNegocio: data[c].codigoNegocio,
                        mensaje: data[c].Mensaje,
                        accesoInicio: data[c].accesoInicio,
                        accesoFin: data[c].accesoFin,
                        idPeriodo: 0,
                        idPersona: 0
                    });
                }

                selListaPostulaciones(false, '', list);
            } else {
                selListaPostulaciones(true, res.errorDetails, list);
            }
        },
    );
};
export const ObtienePostulacionesPostExt = (
    selListaPostulaciones: any,
    headers: any,
    rut: number,
    pasaporte: string,
    anoProceso: number,
    periodoProceso: number,
    codigoNegocio: number,
    codigoPrograma: string,
    codigoPlanificacion: number,
    idPeriodo: number,
) => {
    let list: any = [];
    SVCPostulante.ObtienePostulacionesPostExt(
        headers,
        rut,
        pasaporte,
        anoProceso,
        periodoProceso,
        codigoNegocio,
        codigoPrograma,
        codigoPlanificacion,
        idPeriodo,
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: IViewPostulaciones = res.result;
            selListaPostulaciones(false, '', data);
        } else {
            selListaPostulaciones(true, res.errorDetails, list);
        }
    });
};
export const ObtieneInstrucciones = (selListaInstrucciones: any, codigoNegocio: number, codigoPrograma: string) => {
    let list: Array<IViewInstrucciones> = [];
    SVCPostulante.ObtieneInstrucciones(codigoNegocio, codigoPrograma).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            list.push({
                instrucciones: data,
            });

            selListaInstrucciones(false, '', list);
        } else {
            selListaInstrucciones(true, res.errorDetails, list);
        }
    });
};
export const ObtieneCondiciones = (selListaInstrucciones: any, rut: number) => {
    let list: Array<IViewInstrucciones> = [];
    SVCPostulante.ObtieneCondiciones(rut).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            list.push({
                instrucciones: data,
            });

            selListaInstrucciones(false, '', list);
        } else {
            selListaInstrucciones(true, res.errorDetails, list);
        }
    });
};

export const ObtieneEtapas = (
    selListaEtapas: any,
    codigoNegocio: number,
    codigoPrograma: string,
    CodigoPlanificacionAcademica: number,
    rut: number,
    año: number,
    periodo: number,
    debefirmar: boolean,
) => {
    let list: Array<IViewEtapas> = [];
    SVCPostulante.ObtieneEtapas(codigoNegocio, codigoPrograma, CodigoPlanificacionAcademica, rut, año, periodo).then(
        (res: IServiceResult<any>) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                for (let c = 0; c <= data.length - 1; c++) {
                    list.push({
                        idProceso: data[c].idProceso,
                        idEtapa: data[c].idEtapa,
                        posicion: data[c].posicion,
                        nombre: data[c].nombre,
                        estado: data[c].idEtapa == 1 ? data[c].realizada : false,
                        mwEtapaNegocio: data[c].mwEtapaNegocio,
                    });
                }
                selListaEtapas(false, '', list, debefirmar);
            } else {
                selListaEtapas(true, res.errorDetails, list, debefirmar);
            }
        },
    );
};

export const ObtieneSiguienteEtapa = (selListaEtapas: any, contrato: boolean, pago: boolean) => {
    let list: any = [];
    SVCEtapasProcesos.ObtieneSiguienteEtapa(contrato, pago).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaEtapas(false, '', data);
        } else {
            selListaEtapas(true, res.errorDetails, list);
        }
    });
};
export const ObtieneBeneficioAutomatico = (selObtieneBeneficioAutomatico: any, headers: any, codNegocio: number, codPrograma: string) => {
    let list: any = [];
    SVCEtapasProcesos.ObtieneBeneficioAutomatico(headers, codNegocio, codPrograma).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selObtieneBeneficioAutomatico(false, '', data);
        } else {
            selObtieneBeneficioAutomatico(true, res.errorDetails, list);
        }
    });
};
export const ObtieneBeneficioAutomaticoPorRut = (selListaBeneficiosPorRut: any, codCarr: string, codigoBeneficio: number, rut: number) => {
    let list: any = [];
    SVCEtapasProcesos.ObtieneBeneficioAutomaticoPorRut(codCarr, codigoBeneficio, rut).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaBeneficiosPorRut(false, '', data);
        } else {
            selListaBeneficiosPorRut(true, res.errorDetails, list);
        }
    });
};
export const ObtieneDeudaFinanciera = (selListaEtapas: any, headers: any, rut: number) => {
    let list: any = [];
    SVCEtapasProcesos.ObtieneDeudaFinanciera(headers, rut).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: IViewDeudaFinanciera = res.result;

            selListaEtapas(false, '', data);
        } else {
            selListaEtapas(true, res.errorDetails, list);
        }
    });
};
export const ObtieneDeudaBiblioteca = (selListaEtapas: any, rut: number, ano: number, periodo: number) => {
    let list: any = [];
    SVCEtapasProcesos.ObtieneDeudaBiblioteca(rut, ano, periodo).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaEtapas(false, '', data);
        } else {
            selListaEtapas(true, res.errorDetails, list);
        }
    });
};
export const ObtieneDocumentoLEM = (selListaEtapas: any, rut: number, ano: number, periodo: number) => {
    let list: any = [];
    SVCEtapasProcesos.ObtieneDocumentoLEM(rut, ano, periodo).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaEtapas(false, '', data);
        } else {
            selListaEtapas(true, res.errorDetails, list);
        }
    });
};
export const ObtenerToken = (selListaToken: any, rut: string, fechaNacimiento: Date) => {
    let list: any = [];
    SVCEtapasProcesos.ObtenerToken(rut, fechaNacimiento).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaToken(false, '', data);
        } else {
            selListaToken(true, res.errorDetails, list);
        }
    });
};
export const ObtenerTokenEmail = (selListaToken: any, rut: string, correo: string) => {
    let list: any = [];
    SVCEtapasProcesos.ObtenerTokenEmail(rut, correo).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaToken(false, '', data);
        } else {
            selListaToken(true, res.errorDetails, list);
        }
    });
};
export const ObtenerTokenPostDec = (selListaToken: any, data: any) => {
    let list: any = [];
    SVCEtapasProcesos.ObtenerTokenPostDec(data).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaToken(false, '', data);
        } else {
            selListaToken(true, res.errorDetails, list);
        }
    });
};
